// extracted by mini-css-extract-plugin
module.exports = {"userbutton":"UserIcon-module--userbutton--28ciY","authenticated":"UserIcon-module--authenticated--2dSue"};